export const PRIVATE_FINANCE_PAYMENT_STATUS_LABELS = {
  unset: "Не налаштовано",
  unpaid: "Не оплачено",
  partial: "Частково оплачено",
  paid: "Оплачено",
  overpaid: "Переплата",
};

export const PRIVATE_FINANCE_INCOME_TYPE_LABELS = {
  "": "Не налаштовано",
  percent: "Відсоток",
  fixed: "Фіксована сума",
};

export const getPrivateFinancePaymentStatusLabel = (status) =>
  PRIVATE_FINANCE_PAYMENT_STATUS_LABELS[status] || status || "—";

export const getPrivateFinanceIncomeTypeLabel = (incomeType) =>
  PRIVATE_FINANCE_INCOME_TYPE_LABELS[incomeType] || incomeType || "—";
